import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import NoteIcon from '@material-ui/icons/Note';
import CompanyProductNoteDialog from './CompanyProductNoteDialog';

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}));

export default function ButtonCompanyProductNote({ company_product_id }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        className={classes.button}
        color="primary"
        onClick={handleOpen}
        size="small"
      >
        <NoteIcon />
      </IconButton>
      <CompanyProductNoteDialog
        open={open}
        onClose={handleClose}
        company_product_id={company_product_id}
      />
    </>
  );
} 